<template>
  <transition name="slideAside">
    <div
      v-if="onlyInvisible? true : isOpen"
      v-show="onlyInvisible ? isOpen : true"
      class="aside-filters w-full bg-white right-0 shadow-aside h-full z-50 flex flex-col dark:bg-darkblue-800 select-none"
      :class="[
        large ? 'md:w-120' : 'md:w-96', 
        footer ? 'absolute top-0' : 'fixed bottom-0 md:h-[85vh]'
      ]"
      ref="baseSlidePanel"
      tabIndex="0"
    >
      <div class="overflow-y-auto flex flex-col h-full">
        <header class="sticky top-0 flex-none z-10">
          <slot name="header" />
        </header>
        <div :class="[autoHeight ? 'h-fix' : 'h-full']">
          <slot name="main" />
        </div>
      </div>
      <footer class="flex-none flex items-center justify-end space-x-2 px-4 bg-white dark:bg-darkblue-800 py-2 mt-auto">
        <slot name="footer" />
      </footer>
      <UtilKeys @keyup.esc="closePanel" />
    </div>
  </transition>
</template>

<script>
import UtilKeys from '@/components/utilities/UtilKeys'
export default {
  name: 'base-slide-panel',
  components: {
    UtilKeys
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    onlyInvisible: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    footer: {
      type: Boolean,
      default: true,
    },
    autoHeight: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isOpen: {
      deep: true,
      immediate: true,
      handler: 'watchisOpenHandler'
    },
  },
  methods: {
    closePanel: function () {
      if (this.isOpen) {
        this.$emit('closePanel')
      }
    },
    watchisOpenHandler: async function () {
      const self = this
      setTimeout(() => {
        if (self.isOpen) {
          self.$refs.baseSlidePanel.focus()
        }
      }, 500)
    }
  }
}
</script>

<style lang="scss" scoped>
.slideAside-enter-active,
.slideAside-leave-active {
  transition: all 0.15s;
  transform: translateX(0%);
  opacity: 1;
}
.slideAside-enter,
.slideAside-leave-to {
  transition: all 0.15s;
  transform: translateX(100%);
  opacity: 0;
}
.h-fix {
  height: calc(100% - 64px);
}
</style>
